import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ListenPage from './pages/ListenPage';
import EinkaufslistePage from './pages/EinkaufslistePage';
import VorratPage from './pages/VorratPage';
import EinstellungenPage from './pages/EinstellungenPage';
import ReportPage from './pages/ReportPage';
import Layout from './components/Layout';

export default function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const login = (t) => { localStorage.setItem('token', t); setToken(t); };
  const logout = () => { localStorage.removeItem('token'); setToken(null); };
  if (!token) return <LoginPage onLogin={login} />;
  return (
    <BrowserRouter>
      <Layout onLogout={logout}>
        <Routes>
          <Route path="/" element={<ListenPage />} />
          <Route path="/liste/:id" element={<EinkaufslistePage />} />
          <Route path="/vorrat" element={<VorratPage />} />
          <Route path="/einstellungen" element={<EinstellungenPage />} />
          <Route path="/reports" element={<ReportPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
